import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import axios from 'axios';
import { MixpanelCredentials } from '../types';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useSaveLinkedinCredentials(
  tenant: number,
  options?: UseMutationOptions<
    MixpanelCredentials,
    unknown,
    MixpanelCredentials,
    unknown
  >
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (credentials: MixpanelCredentials) => {
      await axios.post(
        `${getBongoUrl()}/v1/org/${tenant}/integrations/mixpanel/credentials?activate_pull=true`,
        credentials
      );
      return credentials;
    },
    ...options,
    onSuccess: (data, variables, ctx) => {
      options?.onSuccess?.(data, variables, ctx);
      queryClient.setQueryData(['mixpanel', tenant], true);
      queryClient.setQueryData(['mixpanel-credentials', tenant], variables);
    },
  });
}
